<template>
  <div>
    <div class="row">
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card card-primary">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{period}}</h4>
                <p style="font-size: 12px">{{current_datetime}}h</p>
              </div>
              <div class="hidden-xs-down col-md-2" style="text-align: right">
                <i class="fa fa-clock-o fa-4x"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card card-primary">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{pot_contracted}} kW</h4>
                <p style="font-size: 12px">{{web_texts.partials.pot_contracted}}</p>
              </div>
              <div class="hidden-xs-down col-md-2" style="text-align: right">
                <i class="fa fa-flash fa-4x"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card card-warning">
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{Math.round(pot_contracted * 1.05 * 100) / 100}} kW</h4>
                <p style="font-size: 12px">{{web_texts.partials.pot_penalty}}</p>
              </div>
              <div class="col-md-2 hidden-xs-down" style="text-align: right">
                <i class="fa fa-warning fa-4x card-icon"></i>
              </div>
            </div>
          </div>
          <div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-lg-3 col-xl-3">
        <div class="card" :class="class_card_color"><!--:class="class_card_color"-->
          <div class="card-block pb-0">
            <div class="row flex-nowrap">
              <div class="col-md-8">
                <h4 class="mb-0">{{api}} kW</h4>
                <p style="font-size: 12px">{{web_texts.partials.api}}</p>
              </div>
              <div class="col-md-2 hidden-xs-down" style="text-align: right">
                <i class="fa fa-plug fa-4x card-icon"></i>
              </div>
            </div>
          </div>
          <div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.current_tension}}</span>
          </div>
          <div class="card-block">
            <div id="tension-cvmlite" style="height: 300px; width: 100%;"></div>
          </div>
          <div class="card-footer">
            <ul>
              <li>
                <div class="text-muted">F1-F2</div>
                <strong>{{v12}} V</strong>
              </li>
              <li>
                <div class="text-muted">F2-F3</div>
                <strong>{{v23}} V</strong>
              </li>
              <li>
                <div class="text-muted">F3-F1</div>
                <strong>{{v31}} V</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.api_now}}</span>
          </div>
          <div class="card-block">
<!--            <canvas id="active-power-cvmlite" style="height: 295px; width: 100%;"></canvas>-->
            <div id="active-power-cvmlite" style="height: 295px; width: 100%;"></div>
          </div>
          <div class="card-footer">
            <ul>
              <li>
                <div class="text-muted">{{web_texts.partials.api_now}}</div>
                <strong>{{api}} kW</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.active_reactive}}</span>
          </div>
          <div class="card-block">
            <div id="active-reactive-energy-cvmlite" style="height: 295px; width: 100%;"></div>
          </div>
          <div class="card-footer">
            <ul>
              <li>
                <div class="text-muted">{{web_texts.partials.ae}}</div>
                <strong>{{ae}} kW</strong>
              </li>
              <li>
                <div class="text-muted">{{web_texts.partials.ie}}</div>
                <strong>{{ie}} kW</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-6 col-lg-6 col-xl-3">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.cosi}} φ</span>
          </div>
          <div class="card-block">
<!--            <canvas id="cosi-cvmlite" style="height: 295px; width: 100%;"></canvas>-->
            <div id="cosi-cvmlite" style="height: 295px; width: 100%;"></div>
          </div>
          <div class="card-footer">
            <ul>
              <li>
                <div class="text-muted">{{web_texts.partials.cosi}}</div>
                <strong>{{cosi}} φ</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.historical_active_power}}</span>
          </div>
          <div class="card-block">
            <div id="pot-act-cvmlite" style="height: 300px; width: 100%;"></div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6">
        <div class="card">
          <div class="card-header">
            <span>{{web_texts.partials.historical_active_reactive_energy}}</span>
          </div>
          <div class="card-block">
            <div id="energy-cvmlite-act-react" style="height: 300px; width: 100%;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../../../translates/cat/Device';
  import trans_es from '../../../translates/es/Device';
  import constants from '../../../constants';
  import middleware from '../../../utilities/middlewares';
  import dateRanges from '../../../utilities/dates_intervals';
  import dataTransforms from '../../../utilities/data_transformers';

  export default {
    name: '',
    props: ['device_select'],
    data() {
      return {
        web_texts: { "selected_device_t": "Seleccionar Dispositiu", "partials": { "pot_contracted": "Pot. Contractada", "pot_penalty": "Pot. Penalització", "api": "Pot. Actual", "current_tension": "Tensió actual", "api_now": "Potència Activa Instantània", "active_reactive": "Energia activa-reactiva", "ae": "Energia Activa", "ie": "Energia Reactiva", "cosi": "Cosinus de Phi Instantàni", "historical_active_power": "Històric potència activa", "historical_active_reactive_energy": "Històric energia activa-reactiva" } },
        device: '',
        period: 'S/D',
        current_datetime: 'S/D',
        pot_contracted: 'S/D',
        class_card_color: 'card-success',
        cosi: 'S/D',
        api: 'S/D',
        ae: 'S/D',
        ie: 'S/D',
        mdapi: 'S/D',
        v1: "S/D",
        v2: "S/D",
        v3: "S/D",
        v12: "S/D",
        v23: "S/D",
        v31: "S/D"
      }
    },
    created() {
      console.log("Created CVM-lite");
      middleware.userIsLoged();
      this.system = JSON.parse(window.localStorage.getItem('system'));
      this.device = this.device_select;
      window.localStorage.setItem('real_time_control', '["devices",' + this.device.id + ']');
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);
      var out = this;

      this.current_datetime = dateRanges.getCurrentDateTime();
      this.getHeadCardsInfo();

      var cvm_lite_interval = setInterval(function () {
        console.log("Interval CVM-lite");
        var contr_rt = JSON.parse(window.localStorage.getItem('real_time_control'));
        if (contr_rt[1] !== out.device.id) {
          console.log("Clear CVM-lite loop");
          clearInterval(cvm_lite_interval);
        } else {
          console.log("Dev ID: " + out.device.id);
          out.current_datetime = dateRanges.getCurrentDateTime();
          out.getHeadCardsInfo();
          out.getRealTimeValues();
        }
      }, 5000);
    },
    mounted() {
      this.getRealTimeValues();
      this.getDiaryActiveReactiveEnergyCVMLite();
      this.getMonthlyActiveReactiveEnergyCVMLite();
      this.getMonthlyActivePowerCVMLite();
    },
    methods: {
      getHeadCardsInfo() {
        axios.post(constants.ROOT_URL + '/api/v1/get_pow_contracted_per_period_and_current_period', {
          client_device: 'd',
          system_id: this.system.id
        }).then((response) => {
          this.period = response.data.period;
          this.pot_contracted = parseFloat(response.data.pot_contracted);
        }, (response) => {
          console.log(response);
        });
      },
      getRealTimeValues() {
        axios.post(constants.ROOT_URL + '/api/v1/real_time_value', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify([[this.device.id, "COSI", "API", "AE", "IE", "MDI", "VI1", "VI2", "VI3", "VI12", "VI23", "VI31"]])
        }).then((response) => {
          this.cosi = Math.round(response.data[0].value * 100) / 100;
          this.api = Math.round(response.data[1].value * 10) / 10;
          this.ae = Math.round(response.data[2].value * 100) / 100;
          this.ie = Math.round(response.data[3].value * 100) / 100;
          this.mdapi = Math.round(response.data[4].value * 100) / 100;
          this.v1 = Math.round(response.data[5].value * 100) / 100;
          this.v2 = Math.round(response.data[6].value * 100) / 100;
          this.v3 = Math.round(response.data[7].value * 100) / 100;
          this.v12 = Math.round(response.data[8].value * 100) / 100;
          this.v23 = Math.round(response.data[9].value * 100) / 100;
          this.v31 = Math.round(response.data[10].value * 100) / 100;
          this.printTensionGraph();
          this.printPowerGraph();
          this.printCosiGraph();
        }, (response) => {
          console.log(response);
        });
      },
      getDiaryActiveReactiveEnergyCVMLite() {
        axios.post(constants.ROOT_URL + '/api/v1/stored_value', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify([[this.device.id, "AE", "IE"]]),
          date_range: dateRanges.currentDayDaterange()
        }).then((response) => {
          this.printActiveReactiveEnergy(dataTransforms.lineDataTransformCanvasJS(response.data, "line", ["E. Activa", "E. Reactiva"]));
        }, (response) => {
          console.log(response.data);
        });
      },
      getMonthlyActiveReactiveEnergyCVMLite() {
        axios.post(constants.ROOT_URL + '/api/v1/stored_value', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify([[this.device.id, "AE", "IE"]]),
          date_range: dateRanges.currentMonthDaterange()
        }).then((response) => {
          this.printMonthlyActiveReactiveEnergyCVMLite(dataTransforms.lineDataTransformCanvasJS(response.data, "column", ["E. Activa", "E. Reactiva"]));
        }, (response) => {
          console.log(response.data);
        });
      },
      getMonthlyActivePowerCVMLite() {
        axios.post(constants.ROOT_URL + '/api/v1/stored_value', {
          system_id: this.system.id,
          client_device: 'd',
          vars: JSON.stringify([[this.device.id, "API"]]),
          date_range: dateRanges.currentMonthDaterange()
        }).then((response) => {
          this.printMonthlyActivePowerCVMLite(dataTransforms.lineDataTransformCanvasJS(response.data, "line", ["P. Activa"]));
        }, (response) => {
          console.log(response.data);
        });
      },
      printTensionGraph() {
        try {
          var options = {
            data: [
              {
                type: "column",
                dataPoints: [
                  {label: "Tensió L1", y: this.v1},
                  {label: "Tensió L2", y: this.v2},
                  {label: "Tensió L3", y: this.v3}
                ]
              }
            ]
          };

          $("#tension-cvmlite").CanvasJSChart(options);
        } catch (e) {
          console.log("Catch");
        }
      },
      printPowerGraph() {
        // try {
        //   var opts = {
        //     angle: -0.35, // The span of the gauge arc
        //     lineWidth: 0.2, // The line thickness
        //     radiusScale: 0.80, // Relative radius
        //     pointer: {
        //       length: 0.58, // // Relative to gauge radius
        //       strokeWidth: 0.029, // The thickness
        //       color: '#000000' // Fill color
        //     },
        //     limitMax: false,     // If false, max value increases automatically if value > maxValue
        //     limitMin: false,     // If true, the min value of the gauge will be fixed
        //     strokeColor: '#E0E0E0',  // to see which ones work best for you
        //     generateGradient: true,
        //     highDpiSupport: true,     // High resolution support
        //     // renderTicks is Optional
        //     renderTicks: {
        //       divisions: 4,
        //       divWidth: 1.1,
        //       divLength: 0.7,
        //       divColor: '#333333',
        //       subDivisions: 3,
        //       subLength: 0.5,
        //       subWidth: 0.6,
        //       subColor: '#666666'
        //     },
        //     staticLabels: {
        //       font: "12px sans-serif",  // Specifies font
        //       labels: [0, this.pot_contracted, this.pot_contracted * 1.05],  // Print labels at these values
        //       color: "#000000",  // Optional: Label text color
        //       fractionDigits: 0  // Optional: Numerical precision. 0=round off.
        //     },
        //     staticZones: [
        //       {strokeStyle: "rgb(0,255,0)", min: 0, max: this.pot_contracted, height: 1},
        //       {
        //         strokeStyle: "rgb(255,255,0)",
        //         min: this.pot_contracted + 0.0001,
        //         max: this.pot_contracted * 1.05,
        //         height: 1
        //       },
        //       {
        //         strokeStyle: "rgb(255,0,0)",
        //         min: this.pot_contracted * 1.05 + 0.0001,
        //         max: this.pot_contracted * 1.5,
        //         height: 1
        //       }
        //     ]
        //
        //   };
        //   var target = document.getElementById('active-power-cvmlite'); // your canvas element
        //   var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
        //   gauge.maxValue = this.pot_contracted * 1.5; // set max gauge value
        //   gauge.setMinValue(0);  // Prefer setter over gauge.minValue = 0
        //   gauge.animationSpeed = 25; // set animation speed (32 is default value)
        //   gauge.set(this.api); // set actual value
        // } catch (e) {
        //   console.log("Catch");
        // }
        try {
          var myConfig8 = {
            "type": "gauge",
            "scale-r": {
              "aperture": 280,
              "values": "0:"+(this.pot_contracted*1.5)+":"+(this.pot_contracted/5),
              "center": {
                "size": 5,
                "background-color": "#ffff",
                "border-color": "none"
              },
              "markers": [ //Scale Markers
                { //Area Marker 1
                  "type": "area",
                  "range": [0, parseInt(this.pot_contracted)],
                  "offset-start": 0,
                  "offset-end": 0,
                  "background-color": "#00ff00",
                  "alpha": 0.7
                },
                { //Area Marker 2
                  "type": "area",
                  "range": [parseInt(this.pot_contracted), parseInt(this.pot_contracted)*1.05],
                  "offset-start": 0,
                  "offset-end": 0,
                  "background-color": "#FEFE00",
                  "alpha": 0.7
                },
                { //Area Marker 3
                  "type": "area",
                  "range": [parseInt(this.pot_contracted)*1.05, parseInt(this.pot_contracted)*1.4],
                  "offset-start": 0,
                  "offset-end": 0,
                  "background-color": "#DF0000",
                  "alpha": 0.7
                }
              ],
              "ring": {
                "size": 10,
              },
              // "labels": ["0.4", "0.7", "1", "-0.7", "-0.4"],  //Scale Labels
              "item": {  //Scale Label Styling
                "font-color": "black",
                "font-family": "Arial",
                "font-size": 12,
                "font-weight": "bold",   //or "normal"
                "font-style": "normal",   //or "italic"
                "offset-r": 0,
                "angle": "auto"
              }
            },
            "plot": {
              "csize": "5%",
              "size": "100%",
              "background-color": "#ffff"
            },
            "series": [
              {"values": [1.016]}
            ]
          };

          myConfig8.series[0].values[0] = this.api;

          zingchart.render({
            id: 'active-power-cvmlite',
            data: myConfig8,
            height: "100%",
            width: "100%"
          });
        }catch (e) {
          console.log('Catch')
        }
      },
      printActiveReactiveEnergy(data) {
        try {
          //Better to construct options first and then pass it as a parameter
          var options = {
            zoomEnabled: true,
            animationEnabled: true,
            axisX: {
              valueFormatString: "HH:mm"
            },
            axisY: {
              suffix: "kWh"
            },
            data: data  // random data
          };

          $("#active-reactive-energy-cvmlite").CanvasJSChart(options);
        } catch (e) {
          console.log("Catch");
        }
      },
      printCosiGraph() {
        // try {
        //   var opts = {
        //     angle: 0, // The span of the gauge arc
        //     lineWidth: 0.2, // The line thickness
        //     radiusScale: 0.55, // Relative radius
        //     pointer: {
        //       length: 0.58, // // Relative to gauge radius
        //       strokeWidth: 0.025, // The thickness
        //       color: '#000000' // Fill color
        //     },
        //     limitMax: false,     // If false, max value increases automatically if value > maxValue
        //     limitMin: false,     // If true, the min value of the gauge will be fixed
        //     strokeColor: '#E0E0E0',  // to see which ones work best for you
        //     generateGradient: true,
        //     highDpiSupport: true,     // High resolution support
        //     // renderTicks is Optional
        //     renderTicks: {
        //       divisions: 4,
        //       divWidth: 1.1,
        //       divLength: 0.7,
        //       divColor: '#333333',
        //       subDivisions: 3,
        //       subLength: 0.5,
        //       subWidth: 0.6,
        //       subColor: '#666666'
        //     },
        //     staticLabels: {
        //       font: "12px sans-serif",  // Specifies font
        //       labels: [-0.95, 0.95],  // Print labels at these values
        //       color: "#000000",  // Optional: Label text color
        //       fractionDigits: 2  // Optional: Numerical precision. 0=round off.
        //     },
        //     staticZones: [
        //       {strokeStyle: "rgb(0,255,0)", min: -1, max: -0.95, height: 1},
        //       {strokeStyle: "rgb(255,0,0)", min: -0.94, max: 0.94, height: 1},
        //       {strokeStyle: "rgb(0,255,0)", min: 0.95, max: 1, height: 1}
        //     ]
        //   };
        //   var target = document.getElementById('cosi-cvmlite'); // your canvas element
        //   var gauge = new Gauge(target).setOptions(opts); // create sexy gauge!
        //   gauge.maxValue = 1; // set max gauge value
        //   gauge.setMinValue(-1);  // Prefer setter over gauge.minValue = 0
        //   gauge.animationSpeed = 1; // set animation speed (32 is default value)
        //   gauge.set(this.cosi);
        // } catch (e) {
        //   console.log("Catch");
        // }
        try {
          var myConfig8 = {
            "type": "gauge",
            "scale-r": {
              "aperture": 180,
              "values": "0:2:0.5",
              "center": {
                "size": 5,
                "background-color": "#ffff",
                "border-color": "none"
              },
              "markers": [ //Scale Markers
                { //Area Marker 1
                  "type": "area",
                  "range": [0, 0.91],
                  "offset-start": 0,
                  "offset-end": 0,
                  "background-color": "#DF0000",
                  "alpha": 0.7
                },
                { //Area Marker 2
                  "type": "area",
                  "range": [0.91, 1.09],
                  "offset-start": 0,
                  "offset-end": 0,
                  "background-color": "#00ff00",
                  "alpha": 0.7
                },
                { //Area Marker 3
                  "type": "area",
                  "range": [1.09, 2],
                  "offset-start": 0,
                  "offset-end": 0,
                  "background-color": "#d4ff00",
                  "alpha": 0.7
                }
              ],
              "ring": {
                "size": 10,
              },
              "labels": ["0.4", "0.7", "1", "-0.7", "-0.4"],  //Scale Labels
              "item": {  //Scale Label Styling
                "font-color": "black",
                "font-family": "Arial",
                "font-size": 12,
                "font-weight": "bold",   //or "normal"
                "font-style": "normal",   //or "italic"
                "offset-r": 0,
                "angle": "auto"
              }
            },
            "plot": {
              "csize": "5%",
              "size": "100%",
              "background-color": "#ffff"
            },
            "series": [
              {"values": [1.016]}
            ]
          };

          var graph_value = 1;
          if (this.cosi <= 1 && this.cosi > 0) {
            graph_value = ((5 / 3) * (this.cosi - 0.4));
          } else {
            graph_value = ((5 / 3) * (this.cosi + 1)) + 1;
          }

          console.log(graph_value);

          myConfig8.series[0].values[0] = graph_value;

          zingchart.render({
            id: 'cosi-cvmlite',
            data: myConfig8,
            height: "100%",
            width: "100%"
          });
        }catch (e) {
          console.log('Catch')
        }
      },
      printMonthlyActivePowerCVMLite(data) {
        try {
          //Better to construct options first and then pass it as a parameter
          var options = {
            zoomEnabled: true,
            animationEnabled: true,
            axisX: {
              valueFormatString: "DD/MM/YYYY HH:mm"
            },
            axisY: {
              suffix: "kW"
            },
            data: data  // random data
          };

          $("#pot-act-cvmlite").CanvasJSChart(options);
        } catch (e) {
          console.log("Catch");
        }
      },
      printMonthlyActiveReactiveEnergyCVMLite(data) {
        try {
          //Better to construct options first and then pass it as a parameter
          var options = {
            zoomEnabled: true,
            animationEnabled: true,
            axisX: {
              valueFormatString: "DD/MM/YYYY HH:mm"
            },
            axisY: {
              suffix: "kW"
            },
            data: data  // random data
          };

          $("#energy-cvmlite-act-react").CanvasJSChart(options);
        } catch (e) {
          console.log("Catch");
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// LiteAnalyzer.vue?2008eb78